export default __webpack_public_path__ + "static/media/george_xl.fcec5172.jpg";